import React, { useState, useEffect } from 'react';
import { Box, Modal, Typography, Divider } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { REGULAR_EXPRESSIONS } from '../../constants/index';
import { postCreateCompany, deleteCompany } from '../../../../store/bonuses/actions';
import { CustomInput } from '../../../../components/CustomInput';
import { ReactComponent as CloseModalIcon } from '../../../../assets/images/close-modal.svg';
import { ReactComponent as Delete } from '../../../../assets/images/delete.svg';
import { search } from '../../../../utils/search';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  minHeight: 452,
  bgcolor: 'background.paper',
  boxShadow: '0px 12px 32px rgba(42, 70, 94, 0.03)',
  borderRadius: '12px',
  outline: 'none'
};

export const ModalCompany = ({ showModal, setShowModal, companyBonuses, permission }) => {
  const dispatch = useDispatch();
  const [serarch, setSerarch] = useState('');
  const [companies, setCompanies] = useState(companyBonuses);
  const [addCompany, setAddCompany] = useState(false);
  const [newCompany, setNewCompany] = useState('');
  const [error, setError] = useState('');

  const createCompanyHandler = () => dispatch(postCreateCompany({ name: newCompany }));
  const deleteCompanyHandler = (id) => dispatch(deleteCompany(id));

  useEffect(() => {
    search(serarch, setCompanies, companyBonuses, 'name');
  }, [serarch, companyBonuses]);

  const handleNewCompanyInput = (e) => {
    const input = e.target.value;
    if (input && !REGULAR_EXPRESSIONS.modal_and_service.test(input)) setError('Допустимые символы: 0-9, Ая-Яя, Aa-Zz, ", -, _, @.');
    else if (input.length > 100) setError('Максимум 100 символов');
    else setError('');
    setNewCompany(input);
  };

  return (
    <Modal open={showModal} onClose={() => setShowModal(false)} data-testid="Modal">
      <Box sx={style}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p="24px">
          <Typography variant="h5" fontWeight={500}>
            Кампании
          </Typography>
          <CloseModalIcon cursor={'pointer'} onClick={() => setShowModal(false)} data-testid="CloseModal"/>
        </Box>
        <Divider />
        <Box p="24px">
          <CustomInput
            onChange={(e) => setSerarch(e.target.value)}
            value={serarch}
            type="search"
            sx={{ width: '100%' }}
            variant="outlined"
            size="small"
            placeholder="Поиск"
          />

          <Box
            display="flex"
            onClick={() => {
              setAddCompany(true);
            }}
            m="16px 0px"
            width="180px"
            sx={{ cursor: 'pointer' }}
            data-testid="AddCompany"
          >
            <AddIcon sx={{ color: 'primary.main' }} />
            <Typography color="primary.main">Добавить кампанию</Typography>
          </Box>

          {addCompany && (
            <Box display="flex" justifyContent="space-between" alignItems="center" >
              <CustomInput
                data-testid="AddCompanyInput"
                onChange={handleNewCompanyInput}
                value={newCompany}
                sx={{ width: '350px' }}
                error={error}
                helperText={error}
                variant="outlined"
                size="small"
                placeholder="Введите название кампании"
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    createCompanyHandler();
                    setNewCompany('');
                    setAddCompany(false);
                  }
                }}
              />
              <Box>
                <CheckIcon
                  onClick={() => {
                    if (!error) {
                      createCompanyHandler();
                      setNewCompany('');
                      setAddCompany(false);
                    }
                  }}
                  sx={{ marginRight: '15px' }}
                  cursor="pointer"
                  color="success"
                  data-testid="Check"
                />
                <CloseIcon
                  onClick={() => {
                    setNewCompany('');
                    setAddCompany(false);
                  }}
                  color="error"
                  cursor="pointer"
                  data-testid="CloseAddCompany"
                />
              </Box>
            </Box>
          )}

          <Box
            display="flex"
            flexDirection="column"
            maxHeight="600px"
            sx={{
              overflowX: 'scroll',
              '&::-webkit-scrollbar': { width: 0, height: 0 }
            }}>
            {companies?.map((company) => (
              <Box
                display="flex"
                justifyContent="space-between"
                p="8px 0px"
                alignItems="center"
                key={company?.id}>
                <Box data-testid="companyName" sx={{ wordBreak: 'break-word', width: "420px" }}>
                  {company?.name}
                </Box>
                {(!company?.services?.length && permission) && (
                  <Box height="16px" width="16px">
                    <Delete cursor="pointer" onClick={() => deleteCompanyHandler(company?.id)} data-testid="DeleteCompany"/>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

ModalCompany.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  companyBonuses: PropTypes.array,
  permission: PropTypes.bool
};
